import { get } from 'lodash';
import getDebtor from './getDebtor';

const getDebtorTransferredTo = state => get(getDebtor(state), 'transferred_to');

export default getDebtorTransferredTo;
